import { create } from 'zustand';
import { Badge } from '@/types/badge';
import { Certificate } from '@/types/certificate';
import { Course } from '@/types/course';
import { Enrollment } from '@/types/enrollment';
import { LearningUser } from '@/types/learningUser';

interface LearningStore {
  user: LearningUser | null;
  token: string | null;
  courses: Course[];
  enrollments: Enrollment[];
  badges: Badge[];
  certificates: Certificate[];
  loading: boolean;
  error: string | null;
  setAuth: (user: LearningUser, token: string) => void;
  logout: () => void;
  setCourses: (courses: Course[]) => void;
  setEnrollments: (enrollments: Enrollment[]) => void;
  setBadges: (badges: Badge[]) => void;
  setCertificates: (certificates: Certificate[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

const initialToken = localStorage.getItem('learning_token');

export const useStore = create<LearningStore>((set) => ({
  user: null,
  token: initialToken,
  courses: [],
  enrollments: [],
  badges: [],
  certificates: [],
  loading: false,
  error: null,
  setAuth: (user, token) => {
    localStorage.setItem('learning_token', token);
    set({ user, token, error: null });
  },
  logout: () => {
    localStorage.removeItem('learning_token');
    set({
      user: null,
      token: null,
      courses: [],
      enrollments: [],
      badges: [],
      certificates: [],
      error: null,
    });
  },
  setCourses: (courses) => set({ courses }),
  setEnrollments: (enrollments) => set({ enrollments }),
  setBadges: (badges) => set({ badges }),
  setCertificates: (certificates) => set({ certificates }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
